import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  Row } from 'reactstrap';

class PersonifyDecline extends Component {
  render() {
    return (
      <div className="page-personify narrow">
        <Container>
          <Row>
            <Col lg={10} className="text-center mb-2 mt-2 mt-md-5 ml-auto mr-auto">
              <img src="/images/personify-decline.svg" alt="Declined" className="mb-3" />
              <h2 className="mb-2">Unfortunately, we were unable to approve your application at this time.</h2>
              <p className="mb-4">You will receive an adverse action notice within 30 days that will provide you with specific reason(s) as to why we were unable to approve your application.</p>
              <Button tag={Link} to="/dashboard" color="personify" size="lg" className="mb-2 mt-1">Merchant Return to Portal</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default PersonifyDecline;
